<template>
  <div :style="{ display: topdisplayshowhide }" id="nonscrollheader">
    <div class="">
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-3" style="z-index:9;">
          <router-link to="/">
            <div class=" h-100 d-flex justify-content-center align-items-center">
              <div class=" lg-images">
                <img :src="this.adminurl + 'logo.png'" alt="" class="logo-img-width">
              </div>
            </div>
          </router-link>
        </div>
        <div id="topmenuarea" class="col-md-9">
          <div id="HideManu" class="bg-top">
            <ul class="d-flex p-3">
              <li>
                <a class="px-3" href="">
                  <i class="fa fa-volume-control-phone icon-rotete  me-3"></i>Hotline: 09614-50 51 51 </a>
              </li>
              <li>
                <a class="px-3" href="">
                  <i class="fa fa-phone me-3"></i>Phone: +8801730033110 </a>
              </li>
              <li>
                <a class="px-3" href="">
                  <i class="fa fa-envelope-open-o me-3"></i>Email: hospital@pmcbd.com </a>
              </li>
              <li>
                <a class="px-3" href="">
                  <i class="fa fa-clock-o me-3"></i>Open 24/7 Hours </a>
              </li>
              <li>
                <router-link to="NewsEvent" class="px-3 news-event">News & Event</router-link>
              </li>
            </ul>
          </div>
          <div id="mr-hide" class="news-ticker" @mouseenter="pauseTicker" @mouseleave="resumeTicker">
            <div class="news-ticker-content" :class="{ paused: isPaused }" :style="tickerStyle">
              <ul class="d-flex gap-1">
                <li v-for="newsItem in newsItems" :key="newsItem.id">{{ newsItem.title }}</li>
              </ul>
            </div>
          </div>
          <div class="text-white main-header-nav">
            <nav class="navbar bootsnav navbar-expand-lg ">
              <div class="navbar-header"></div>
              <div class="collapse navbar-collapse" id="navbar-menu">
                <ul class="nav navbar-nav navbar-left" data-in="fadeIn">
                  <li class="nav-item">
                    <router-link to="/" class="nav-link ">Home</router-link>
                  </li>
                  <li class="nav-item dropdown">
                    <a href="#" class="nav-link" data-toggle="dropdown">About Us <i class="fa fa-angle-down color-blue ms-2 "></i>
                    </a>
                    <ul class="dropdown-menu">
                      <li>
                        <router-link to="/about">About Us</router-link>
                      </li>
                      <li v-for="management in managementCatagory" :key="management.id">
                        <router-link :to="`/manegments/${management.id}`">{{ management.title }}
                        </router-link>
                      </li>
                    </ul>
                  </li>
                  <li class="nav-item ">
                    <router-link to="/appointment" class="nav-link">Appointment</router-link>
                  </li>
                  <li class="nav-item dropdown">
                    <a href="#" class="nav-link" data-toggle="dropdown">Service <i class="fa fa-angle-down color-blue ms-2 "></i>
                    </a>
                    <ul class="dropdown-menu">
                      <li>
                        <router-link to="/Card-service">Customer Service</router-link>
                      </li>
                      <li>
                        <router-link to="/Cabin-service">IPD Service</router-link>
                      </li>
                      <li>
                        <router-link to="/Diagnostics">Diagnostic Service</router-link>
                      </li>
                    </ul>
                  </li>
                  <li class="nav-item dropdown">
                    <router-link to="/doctors" class="nav-link" data-toggle="dropdown">Our Doctors</router-link>
                    <ul class="dropdown-menu"></ul>
                  </li>
                  <li class="nav-item dropdown megamenu-fw">
                    <a href="#" class="nav-link" data-toggle="dropdown"> Department <i class="fa fa-angle-down color-blue ms-2 "></i>
                    </a>
                    <ul class="dropdown-menu megamenu-content" role="menu">
                      <li>
                        <div class="row">
                          <div class="col-menu col-md-3">
                            <h4 class="title">Clinical</h4>
                            <div class="content">
                              <ul class="menu-col">
                                <li>
                                  <router-link to="/MedicineAllied">Medicine & Allied </router-link>
                                </li>
                                <li>
                                  <router-link to="/SurgeryAllied">Surgery & Allied </router-link>
                                </li>
                                <li>
                                  <router-link to="/Obsgynae">Obs &Gynae</router-link>
                                </li>
                                <li>
                                  <router-link to="/Pediatric">Pediatrics</router-link>
                                </li>
                                <li>
                                  <router-link to="/Emergency">Emergency</router-link>
                                </li>
                                <li>
                                  <router-link to="/Dialysis_Center" href="">Dialysis Center </router-link>
                                </li>
                                <li>
                                  <router-link to="/Chemotherapy_Center">Chemotherapy Center </router-link>
                                </li>
                                <li>
                                  <router-link to="/Physiotherapy_Center">Physiotherapy Center </router-link>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <!-- end col-3 -->
                          <div class="col-menu col-md-3">
                            <h4 class="title">Special</h4>
                            <div class="content">
                              <ul class="menu-col">
                                <li>
                                  <router-link to="/ICU">ICU</router-link>
                                </li>
                                <li>
                                  <router-link to="/NICU">NICU</router-link>
                                </li>
                                <li>
                                  <router-link to="/CCU">CCU</router-link>
                                </li>
                                <li>
                                  <router-link to="/HDU">HDU.MHDU</router-link>
                                </li>
                                <li>
                                  <router-link to="/DiabeticClub">Diabetic Club </router-link>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <!-- end col-3 -->
                          <div class="col-menu col-md-3">
                            <h4 class="title">Allied</h4>
                            <div class="content">
                              <ul class="menu-col">
                                <li>
                                  <router-link to="/Dentistry">Dentistry</router-link>
                                </li>
                                <li>
                                  <router-link to="/EPICorner">EPI Corner </router-link>
                                </li>
                                <li>
                                  <router-link to="/BloodBank">Blood Bank </router-link>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div class="col-menu col-md-3">
                            <h4 class="title">Upcoming</h4>
                            <div class="content">
                              <ul class="menu-col">
                                <li>
                                  <router-link to="/Caner_Center">Cancer Center </router-link>
                                </li>
                                <li>
                                  <router-link to="/CardiacCenter">Cardiac Center </router-link>
                                </li>
                                <li>
                                  <router-link to="/UrologyCenter"> Urology Center </router-link>
                                </li>
                                <li>
                                  <router-link to="/IVFCenter"> IVF Center </router-link>
                                </li>
                                <li>
                                  <router-link to="/CSSD"> CSSD</router-link>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <!-- end col-3 -->
                        </div>
                        <!-- end row -->
                      </li>
                    </ul>
                  </li>
                  <li class="nav-item dropdown">
                    <router-link to="/Career" class="nav-link" data-toggle="dropdown">Career</router-link>
                  </li>
                  <li class="nav-item dropdown">
                    <router-link to="/Notice" class="nav-link" data-toggle="dropdown">Notice</router-link>
                  </li>
                  <li class="nav-item dropdown">
                    <a href="#" class="nav-link" data-toggle="dropdown">Contact Us <i class="fa fa-angle-down color-blue ms-2 "></i>
                    </a>
                    <ul class="dropdown-menu">
                      <li>
                        <router-link to="/contactUs">Contact Us</router-link>
                      </li>
                      <li>
                        <router-link to="/ComplaintBox">Suggestion box</router-link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- sticky manu state -->
  <div id="scrollmanu" :style="{ display: bottomdisplayshowhide }">
    <div class="scrollMenu">
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-3" style="z-index:9;">
          <router-link to="/">
            <div class=" h-100 d-flex justify-content-center align-items-center">
              <div class=" lg-images">
                <img :src="this.adminurl + 'logo.png'" alt="" class="sticky-logo-img-width">
              </div>
            </div>
          </router-link>
        </div>
        <div class="col-md-9">
          <div class="text-white main-header-nav">
            <nav class="navbar bootsnav navbar-expand-lg ">
              <div class="collapse navbar-collapse" id="navbar-menu">
                <ul class="nav navbar-nav navbar-left" data-in="fadeIn">
                  <li class="nav-item">
                    <router-link to="/" class="nav-link ">Home</router-link>
                  </li>
                  <li class="nav-item dropdown">
                    <a href="#" class="nav-link" data-toggle="dropdown">About Us <i class="fa fa-angle-down color-blue ms-2 "></i>
                    </a>
                    <ul class="dropdown-menu">
                      <li>
                        <router-link to="/About Us">About Us</router-link>
                      </li>
                      <li v-for="management in managementCatagory" :key="management.id">
                        <router-link :to="`/manegments/${management.id}`">{{ management.title }}
                        </router-link>
                      </li>
                    </ul>
                  </li>
                  <li class="nav-item ">
                    <router-link to="/appointment" class="nav-link">Appointment</router-link>
                  </li>
                  <li class="nav-item dropdown">
                    <a href="#" class="nav-link" data-toggle="dropdown">Service <i class="fa fa-angle-down color-blue ms-2 "></i>
                    </a>
                    <ul class="dropdown-menu">
                      <li>
                        <router-link to="/Card-service">Customer Service</router-link>
                      </li>
                      <li>
                        <router-link to="/Cabin-service">IPD Service</router-link>
                      </li>
                      <li>
                        <router-link to="/Diagnostics">Diagnostic Service</router-link>
                      </li>
                    </ul>
                  </li>
                  <li class="nav-item dropdown">
                    <router-link to="/doctors" class="nav-link" data-toggle="dropdown">Our Doctors</router-link>
                    <ul class="dropdown-menu"></ul>
                  </li>
                  <li class="nav-item dropdown megamenu-fw">
                    <a href="#" class="nav-link" data-toggle="dropdown"> Department <i class="fa fa-angle-down color-blue ms-2 "></i>
                    </a>
                    <ul class="dropdown-menu megamenu-content" role="menu">
                      <li>
                        <div class="row">
                          <div class="col-menu col-md-3">
                            <h4 class="title">Clinical</h4>
                            <div class="content">
                              <ul class="menu-col">
                                <li>
                                  <router-link to="/MedicineAllied">Medicine & Allied </router-link>
                                </li>
                                <li>
                                  <router-link to="/SurgeryAllied">Surgery & Allied </router-link>
                                </li>
                                <li>
                                  <router-link to="/Obsgynae">Obs & Gynae </router-link>
                                </li>   
                                <li>
                                  <router-link to="/Pediatric">Pediatrics</router-link>
                                </li>
                                <li>
                                  <router-link to="/Emergency">Emergency</router-link>
                                </li>
                                <li>
                                  <router-link to="/Dialysis_Center" href="">Dialysis Center </router-link>
                                </li>
                                <li>
                                  <router-link to="/Chemotherapy_Center">Chemotherapy Center </router-link>
                                </li>
                                <li>
                                  <router-link to="/Physiotherapy_Center">Physiotherapy Center </router-link>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <!-- end col-3 -->
                          <div class="col-menu col-md-3">
                            <h4 class="title">Special</h4>
                            <div class="content">
                              <ul class="menu-col">
                                <li>
                                  <router-link to="/ICU">ICU</router-link>
                                </li>
                                <li>
                                  <router-link to="/NICU">NICU</router-link>
                                </li>
                                <li>
                                  <router-link to="/CCU">CCU</router-link>
                                </li>
                                <li>
                                  <router-link to="/HDU">HDU.MHDU</router-link>
                                </li>
                                <li>
                                  <router-link to="/DiabeticClub">Diabetic Club </router-link>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <!-- end col-3 -->
                          <div class="col-menu col-md-3">
                            <h4 class="title">Allied</h4>
                            <div class="content">
                              <ul class="menu-col">
                                <li>
                                  <router-link to="/Dentistry">Dentistry</router-link>
                                </li>
                                <li>
                                  <router-link to="/EPICorner">EPI Corner </router-link>
                                </li>
                                <li>
                                  <router-link to="/BloodBank">Blood Bank </router-link>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div class="col-menu col-md-3">
                            <h4 class="title">Upcoming</h4>
                            <div class="content">
                              <ul class="menu-col">
                                <li>
                                  <router-link to="/Caner_Center">Cancer Center </router-link>
                                </li>
                                <li>
                                  <router-link to="/CardiacCenter">Cardiac Center </router-link>
                                </li>
                                <li>
                                  <router-link to="/UrologyCenter"> Urology Center </router-link>
                                </li>
                                <li>
                                  <router-link to="/IVFCenter"> IVF Center </router-link>
                                </li>
                                <li>
                                  <router-link to="/CSSD"> CSSD</router-link>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <!-- end col-3 -->
                        </div>
                        <!-- end row -->
                      </li>
                    </ul>
                  </li>
                  <li class="nav-item dropdown">
                    <router-link to="/Career" class="nav-link" data-toggle="dropdown">Career</router-link>
                  </li>
                  <li class="nav-item dropdown">
                    <router-link to="/Notice" class="nav-link" data-toggle="dropdown">Notice</router-link>
                  </li>
                  <li class="nav-item dropdown">
                    <a href="#" class="nav-link" data-toggle="dropdown">Contact Us <i class="fa fa-angle-down color-blue ms-2 "></i>
                    </a>
                    <ul class="dropdown-menu">
                      <li>
                        <router-link to="/contactUs">Contact Us</router-link>
                      </li>
                      <li>
                        <router-link to="/ComplaintBox">Complaint Box</router-link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- sticky manu end -->
  <!-- mobile manu -->
  <header id="mobilemanu" class="mobilemanu">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-7">
          <a :href="url + '/'">
            <div class="mobile-logo">
              <img src="images/logo/primeHeaderLogo.png" alt="">
            </div>
          </a>
        </div>
        <div class="col-sm-5">
          <div class="text-end">
            <i class="fa fa-bars menu-icon" @click="toggleSidebar"></i>
          </div>
        </div>
      </div>
    </div>
  </header>
  <aside :class="['sidebar', { open: isSidebarOpen }]">
    <!-- Close Icon -->
    <a>
      <div class="mobile-top my-5">
        <img class="" src="images/logo/primeHeaderLogo.png" alt="">
        <i class="fa fa-times close-icon" @click="toggleSidebar"></i>
      </div>
    </a>
    <router-link to="/" @click="toggleSidebar">
      <div class="bg-aside">
        <ul>
          <div class="w-100 d-flex justify-content-between px-4 py-3">
            <a class="fw-bold text-white nav-text-style ">Home</a>
          </div>
        </ul>
      </div>
    </router-link>
    <router-link to="/about" @click="toggleSidebar">
      <div class="bg-aside">
        <ul>
          <div class="w-100 d-flex justify-content-between px-4 py-3">
            <a class="fw-bold text-white nav-text-style ">About</a>
          </div>
        </ul>
      </div>
    </router-link>
    <router-link to="/appointment" @click="toggleSidebar">
      <div class="bg-aside">
        <ul>
          <div class="w-100 d-flex justify-content-between px-4 py-3">
            <a class="fw-bold text-white nav-text-style" href="#">Appoinment</a>
          </div>
        </ul>
      </div>
    </router-link>
    <router-link to="/doctors" @click="toggleSidebar">
      <div class="bg-aside">
        <ul>
          <div class="w-100 d-flex justify-content-between px-4 py-3">
            <a class="fw-bold text-white nav-text-style">Our Doctors</a>
          </div>
        </ul>
      </div>
    </router-link>
    <router-link to="/card-service" @click="toggleSidebar">
      <div class="bg-aside">
        <ul>
          <div class="w-100 d-flex justify-content-between px-4 py-3">
            <a class="fw-bold text-white nav-text-style">Customer Service</a>
          </div>
        </ul>
      </div>
    </router-link>
    <router-link to="/Cabin-service" @click="toggleSidebar">
      <div class="bg-aside">
        <ul>
          <div class="w-100 d-flex justify-content-between px-4 py-3">
            <a class="fw-bold text-white nav-text-style" href="#">IPD Service</a>
          </div>
        </ul>
      </div>
    </router-link>
    <router-link to="/Diagnostics" @click="toggleSidebar">
      <div class="bg-aside">
        <ul>
          <div class="w-100 d-flex justify-content-between px-4 py-3">
            <a class="fw-bold text-white nav-text-style" href="#">Diagnostic Service</a>
          </div>
        </ul>
      </div>
    </router-link>
    <div v-for="management in managementCatagory" :key="management.id" class="bg-aside">
      <router-link :to="`/manegments/${management.id}`" @click="toggleSidebar">
        <ul>
          <div class="w-100 d-flex justify-content-between px-4 py-3">
            <a class="fw-bold text-white nav-text-style">{{ management.title }}</a>
          </div>
        </ul>
      </router-link>
    </div>
    <router-link to="/MedicineAllied" @click="toggleSidebar">
      <div class="bg-aside">
        <ul>
          <div class="w-100 d-flex justify-content-between px-4 py-3">
            <a class="fw-bold text-white nav-text-style">Medicine & Allied</a>
          </div>
        </ul>
      </div>
    </router-link>
    <router-link to="/SurgeryAllied" @click="toggleSidebar">
      <div class="bg-aside">
        <ul>
          <div class="w-100 d-flex justify-content-between px-4 py-3">
            <a class="fw-bold text-white nav-text-style">Surgery & Allied</a>
          </div>
        </ul>
      </div>
    </router-link>
    <router-link to="/Obsgynae" @click="toggleSidebar">
      <div class="bg-aside">
        <ul>
          <div class="w-100 d-flex justify-content-between px-4 py-3">
            <a class="fw-bold text-white nav-text-style">Obs & Gynae</a>
          </div>
        </ul>
      </div>
    </router-link>    
    <router-link to="/Pediatric" @click="toggleSidebar">
      <div class="bg-aside">
        <ul>
          <div class="w-100 d-flex justify-content-between px-4 py-3">
            <a class="fw-bold text-white nav-text-style">Pediatric</a>
          </div>
        </ul>
      </div>
    </router-link>
    <router-link to="/Emergency" @click="toggleSidebar">
      <div class="bg-aside">
        <ul>
          <div class="w-100 d-flex justify-content-between px-4 py-3">
            <a class="fw-bold text-white nav-text-style">Emergency</a>
          </div>
        </ul>
      </div>
    </router-link>
    <router-link to="/ICU" @click="toggleSidebar">
      <div class="bg-aside">
        <ul>
          <div class="w-100 d-flex justify-content-between px-4 py-3">
            <a class="fw-bold text-white nav-text-style">ICU</a>
          </div>
        </ul>
      </div>
    </router-link>
    <router-link to="/NICU" @click="toggleSidebar">
      <div class="bg-aside">
        <ul>
          <div class="w-100 d-flex justify-content-between px-4 py-3">
            <a class="fw-bold text-white nav-text-style">NICU</a>
          </div>
        </ul>
      </div>
    </router-link>
    <router-link to="/CCU" @click="toggleSidebar">
      <div class="bg-aside">
        <ul>
          <div class="w-100 d-flex justify-content-between px-4 py-3">
            <a class="fw-bold text-white nav-text-style">CCU</a>
          </div>
        </ul>
      </div>
    </router-link>
    <router-link to="/HDU" @click="toggleSidebar">
      <div class="bg-aside">
        <ul>
          <div class="w-100 d-flex justify-content-between px-4 py-3">
            <a class="fw-bold text-white nav-text-style">HDU.MHDU</a>
          </div>
        </ul>
      </div>
    </router-link>
    <router-link to="/DiabeticClub" @click="toggleSidebar">
      <div class="bg-aside">
        <ul>
          <div class="w-100 d-flex justify-content-between px-4 py-3">
            <a class="fw-bold text-white nav-text-style">Diabetic Club</a>
          </div>
        </ul>
      </div>
    </router-link>
    <router-link to="/Dentistry" @click="toggleSidebar">
      <div class="bg-aside">
        <ul>
          <div class="w-100 d-flex justify-content-between px-4 py-3">
            <a class="fw-bold text-white nav-text-style" @click="toggleSidebar">Dentistry</a>
          </div>
        </ul>
      </div>
    </router-link>
    <router-link to="/EPICorner" @click="toggleSidebar">
      <div class="bg-aside">
        <ul>
          <div class="w-100 d-flex justify-content-between px-4 py-3">
            <a class="fw-bold text-white nav-text-style">Epi Corner</a>
          </div>
        </ul>
      </div>
    </router-link>
    <router-link to="/BloodBank" @click="toggleSidebar">
      <div class="bg-aside">
        <ul>
          <div class="w-100 d-flex justify-content-between px-4 py-3">
            <a class="fw-bold text-white nav-text-style">blood Bank</a>
          </div>
        </ul>
      </div>
    </router-link>
    <router-link to="/Dialysis_Center" @click="toggleSidebar">
      <div class="bg-aside">
        <ul>
          <div class="w-100 d-flex justify-content-between px-4 py-3">
            <a class="fw-bold text-white nav-text-style">Dialysis Center</a>
          </div>
        </ul>
      </div>
    </router-link>
    <router-link to="/Chemotherapy_Center" @click="toggleSidebar">
      <div class="bg-aside">
        <ul>
          <div class="w-100 d-flex justify-content-between px-4 py-3">
            <a class="fw-bold text-white nav-text-style">Chemotherapy Center</a>
          </div>
        </ul>
      </div>
    </router-link>
    <router-link to="/Physiotherapy_Center" @click="toggleSidebar">
      <div class="bg-aside">
        <ul>
          <div class="w-100 d-flex justify-content-between px-4 py-3">
            <a class="fw-bold text-white nav-text-style">Physiotherapy</a>
          </div>
        </ul>
      </div>
    </router-link>
    <router-link to="/Caner_Center" @click="toggleSidebar">
      <div class="bg-aside">
        <ul>
          <div class="w-100 d-flex justify-content-between px-4 py-3">
            <a class="fw-bold text-white nav-text-style">Cancer Center</a>
          </div>
        </ul>
      </div>
    </router-link>
    <router-link to="/CardiacCenter" @click="toggleSidebar">
      <div class="bg-aside">
        <ul>
          <div class="w-100 d-flex justify-content-between px-4 py-3">
            <a class="fw-bold text-white nav-text-style">Cardiac Center</a>
          </div>
        </ul>
      </div>
    </router-link>
    <router-link to="/UrologyCenter" @click="toggleSidebar">
      <div class="bg-aside">
        <ul>
          <div class="w-100 d-flex justify-content-between px-4 py-3">
            <a class="fw-bold text-white nav-text-style nav-text-style">Urology Center</a>
          </div>
        </ul>
      </div>
    </router-link>
    <router-link to="/IVFCenter" @click="toggleSidebar">
      <div class="bg-aside">
        <ul>
          <div class="w-100 d-flex justify-content-between px-4 py-3">
            <a class="fw-bold text-white nav-text-style">IVF Center</a>
          </div>
        </ul>
      </div>
    </router-link>
    <router-link to="/CSSD" @click="toggleSidebar">
      <div class="bg-aside">
        <ul>
          <div class="w-100 d-flex justify-content-between px-4 py-3">
            <a class="fw-bold text-white nav-text-style">CSSD</a>
          </div>
        </ul>
      </div>
    </router-link>
    <router-link to="/Career" @click="toggleSidebar">
      <div class="bg-aside">
        <ul>
          <div class="w-100 d-flex justify-content-between px-4 py-3">
            <a class="fw-bold text-white nav-text-style">Career</a>
          </div>
        </ul>
      </div>
    </router-link>
    <router-link to="/Notice" @click="toggleSidebar">
      <div class="bg-aside">
        <ul>
          <div class="w-100 d-flex justify-content-between px-4 py-3">
            <a class="fw-bold text-white nav-text-style">Notice</a>
          </div>
        </ul>
      </div>
    </router-link>
    <router-link to="/contactUs" @click="toggleSidebar">
      <div class="bg-aside">
        <ul>
          <div class="w-100 d-flex justify-content-between px-4 py-3">
            <a class="fw-bold text-white nav-text-style">Contact Us</a>
          </div>
        </ul>
      </div>
    </router-link>
    <router-link to="/ComplaintBox" @click="toggleSidebar">
      <div class="bg-aside">
        <ul>
          <div class="w-100 d-flex justify-content-between px-4 py-3">
            <a class="fw-bold text-white nav-text-style">Suggestion box</a>
          </div>
        </ul>
      </div>
    </router-link>
  </aside>
</template>
<script>
  import {
    ref
  } from "vue";
  import axios from 'axios';
  export default {
    name: "NewsTicker",
    computed: {
      adminurl() {
        return this.$store.state.adminurl;
      },
      url() {
        return this.$store.state.url;
      },
    },
    data() {
      return {
        managementCatagory: [],
        showDropdown: null,
        hasScrolled: false,
        bottomdisplayshowhide: 'none',
        topdisplayshowhide: 'block',
        newsItems: [],
        newsText: "",
        isPaused: false,
        interval: null,
        tickerDuration: '40s',
      };
    },
    mounted() {
      this.updateNewsTicker();
      this.updateTickerStyle();
      this.interval = setInterval(this.updateNewsTicker, 10000);
      // Add scroll event listener when the component is mounted
      window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
      // Remove event listener when the component is destroyed
      window.removeEventListener('scroll', this.handleScroll);
    },
    created() {
      // Make an AJAX call to the Laravel API Our Management Team
      axios.get(this.adminurl + 'api/management_category').then(response => {
        this.managementCatagory = response.data.categoris;
      }).catch(error => {
        console.error('Error fetching data:', error);
      });
      this.loadtitle();
    },
    methods: {
      loadtitle() {
        axios.get(this.adminurl + 'api/NewsTiker').then(response => {
          console.log('Data fetched:', response.data); // Check if data is fetched correctly
          this.newsItems = response.data.newstikers;
        }).catch(error => {
          console.error('Error fetching news:', error); // Log any errors that occur
        });
      },
      generateNewsText() {
        this.newsText = this.newsItems.join(" | ") + " | ";
      },
      pauseTicker() {
        this.isPaused = true;
      },
      resumeTicker() {
        this.isPaused = false;
      },
      updateNewsTicker() {
        this.generateNewsText();
      },
      updateTickerStyle() {
        if (this.newsText.length > 10) {
          // Set the first 10 chars to scroll in 2 seconds
          this.tickerDuration = '1s';
          setTimeout(() => {
            // After 2 seconds, set the rest of the ticker to scroll for 40 seconds
            this.tickerDuration = '40s';
          }, 2000); // Delay for 2 seconds
        }
      },
      handleScroll() {
        if (window.scrollY >= 100) {
          this.hasScrolled = false;
          this.bottomdisplayshowhide = 'block';
          this.topdisplayshowhide = '';
        } else {
          this.hasScrolled = false;
          this.topdisplayshowhide = 'block';
          this.bottomdisplayshowhide = 'none';
        }
      },
    },
    setup() {
      // Reactive variable for sidebar state
      const isSidebarOpen = ref(false);
      // Function to toggle the sidebar
      const toggleSidebar = () => {
        isSidebarOpen.value = !isSidebarOpen.value;
      };
      return {
        isSidebarOpen,
        toggleSidebar,
      };
    },
    beforeUnmount() {
      clearInterval(this.interval);
    }
  };
</script>
<style scoped>
  #nonscrollheader {
    position: relative;
  }

  .sticky-logo-img-width {
    width: 196px;
    padding: 10px 20px;
  }

  .scrollMenu {
    top: 0;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    position: fixed;
    width: 100%;
    background-color: white;
    text-align: center;
    z-index: 9;
  }

  .dropdown-menu.sub-class {
    max-height: 400px;
    overflow-y: scroll;
  }

  .custom-drop {
    display: block;
    position: absolute;
    background-color: white;
    width: 100%;
    box-shadow: 10px 8px 16px;
  }

  .custom-drop li {
    padding: 8px 12px;
  }

  .custom-drop li a {
    color: green;
    font-weight: 700;
  }

  .custom-drop li:hover {
    background-color: #218847;
    color: white;
  }

  .custom-drop li a:hover {
    color: white;
  }

  .mobilemanu {
    top: 0 !important;
    width: 100%;
    position: fixed !important;
    background-color: #f7f7f7;
    color: #fff;
    display: flex;
    z-index: 9;
    align-items: center;
    padding: 10px 20px;
    position: relative;
  }

  .menu-icon {
    color: #000;
    cursor: pointer;
    margin-top: 54px;
    border: 1px solid silver;
    padding: 25px;
    font-size: 73px;
    margin-right: 0px;
  }

  .mobile-top img {
    width: 60%;
  }

  .sidebar {
    z-index: 9;
    position: fixed;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background-color: #f7f7f7;
    /* color: #fff; */
    overflow-y: scroll;
    transition: 0.3s ease;
    padding: 10px;
  }

  .close-icon {
    -webkit-text-stroke-color: #000;
    margin-right: 61px;
    -webkit-text-stroke-width: 2.2px;
    font-size: 75px;
    margin-top: 77px;
    position: absolute;
    right: 0;
    opacity: 0.8;
  }

  .sidebar.open {
    left: 0;
  }

  .sidebar ul {
    list-style: none;
    padding: 0;
  }

  .sidebar ul li {
    padding: 10px 20px;
  }

  .sidebar ul li a {
    color: #008c42;
    font-family: 'Ubuntu';
    font-weight: 700;
    text-decoration: none;
    font-size: 31px;
  }

  #mobilemanu {
    display: none;
  }

  .bg-top {
    background-color: #008c42;
  }

  .bg-top ul li a {
    font-family: 'Ubuntu';
    font-size: 15px;
    padding: 10px;
    font-weight: 400;
    color: #ffffff;
  }

  .icon-rotete {
    transform: rotate(326deg);
  }

  .h-100 {
    position: relative;
  }

  .lg-images:before {
    content: " ";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    background-color: #fff;
    border-right: 2px solid #1db9a0;
    transform: skewX(-25deg);
    z-index: -1;
  }

  #topmenuarea {
    position: relative;
    /* left: -21px;
        position: relative; */
  }

  #topmenuarea::before {
    content: " ";
    position: absolute;
    width: 32px;
    height: 45px;
    background: #008c42;
    left: -14px;
  }

  .logo-img-width {
    padding: 8px;
    /* width: 125px; */
  }

  .color-blue {
    color: #008c42;
  }

  .menu-col li a:hover {
    padding-left: 15px !important;
    color: white !important;
    background: #008c42 !important;
  }

  .news-ticker {
    color: red;
    overflow: hidden;
    white-space: nowrap;
    position: relative;
  }

  .news-ticker-content {
    font-family: "Aldrich", Sans-serif;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.1px;
    word-spacing: 2px;
    font-size: 13px;
    -webkit-text-stroke-width: 0.2px;
    stroke-width: 0.3px;
    -webkit-text-stroke-color: #000;
    stroke: #000;
    text-shadow: 11px 6px 21px;
    color: #008c42;
    display: inline-block;
    white-space: nowrap;
    animation: scrollNews 40s linear infinite;
  }

  @keyframes scrollNews {
    from {
      transform: translateX(100%);
    }

    to {
      transform: translateX(-100%);
    }
  }

  .paused {
    animation-play-state: paused !important;
  }
</style>